import { Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { IsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import TenantPage from 'layouts/TenantPage';
import { regionalRateService } from 'shared/services';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { RegionalRateColumns } from '../regional-rates';

export const RegionalRates = () => {
  const translationPrefix = 'pages.regional-rate.list';

  const { t } = useTranslation();

  const columns: GridColDef[] = RegionalRateColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <ButtonGroup>
          <IsTenantAdministrator>
            <Link to="new">
              <Button color="primary" size="small">
                <AddIcon />
                {t(`${translationPrefix}.add`)}
              </Button>
            </Link>
          </IsTenantAdministrator>
        </ButtonGroup>
      }>
      <EnhancedDataGrid columns={columns} service={regionalRateService} />
    </TenantPage>
  );
};

export default RegionalRates;
